import ItemSurah from "./itemsurah";

function ListSurah({ listsurah, getDetailSurah }) {
  return (
    <div className="h-full w-full p-4 overflow-y-auto scrollbar-hide">
      {listsurah.map((surah, index) => (
        <di onClick={() => getDetailSurah(surah.nomor)} key={index}>
          <ItemSurah
            nomor={surah.nomor}
            namaSurah={surah.nama_latin}
            artiSurah={surah.arti}
            tempatTurunSurah={surah.tempat_turun}
            jumlahAyat={surah.jumlah_ayat}
            getDetailSurah
          />
        </di>
      ))}
    </div>
  );
}

export default ListSurah;


